import { WEBSITE_URL } from 'core-lib/data/common';
import formatCurrency from 'core-lib/utils/currency';
import { Divider, Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';
import s from './BestCarsList.module.scss';
import { formatTitleCase } from 'core-lib/utils/common';
import { toTitleCase } from 'core-lib/utils/utils';
type CarsProp = {
  heading: string;
  componentRef: any;
  bestCars: any;
};
export const BestCarsList = ({ heading, componentRef, bestCars }: CarsProp) => {
  return (
    <div className={s.root}>
      <div className={s.carListing}>
        <div className={s.box_title}>
          <Typography
            label={heading}
            variant={TypeScales.h2}
            renderAs="H2"
            color={Color.text_default}
          />
        </div>
        <div className={s.displayBox} ref={componentRef}>
          <div className={s.listHeading}>
            <Typography
              label="Cars"
              variant={TypeScales.h4}
              renderAs="H4"
              color={Color.text_default}
            />
            <Typography
              label="Price start at"
              variant={TypeScales.h4}
              renderAs="H4"
              color={Color.text_default}
            />
          </div>
          <div className={s.listContent}>
            {bestCars?.map((each, index, cars) => {
              const redirectionUrl = `${WEBSITE_URL}/new-cars/${each.brandSlug}/${each.modelSlug}`;

              return (
                <>
                  <div className={s.carDetails}>
                    <a href={redirectionUrl}>
                      <Typography
                        label={each.name}
                        variant={TypeScales.base_big_m}
                        color={Color.text_default}
                      />
                    </a>
                    <Typography
                      label={formatCurrency(each.startingPrice)}
                      variant={TypeScales.base_big_m}
                      color={Color.text_default}
                    />
                  </div>
                  {index != cars.length - 1 && (
                    <Divider className={s.divider} />
                  )}
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
